import { CalendarDuration, CalendarDurationType } from "@oysterhr/schema"

export const convertToDays = (unit: CalendarDurationType, value: number) => {
  switch (unit) {
    case CalendarDurationType.Days:
      return value
    case CalendarDurationType.Weeks:
      return value * 7
    case CalendarDurationType.Months:
      return value * 30
    case CalendarDurationType.Years:
      return value * 365
    default:
      return value
  }
}

export const maxDuration = (durations: CalendarDuration[]) => {
  if (!durations?.length) {
    return null
  }

  const max = durations?.reduce((acc, cur) => {
    if (cur.value == null || acc.value == null) return acc
    const convertedCur = convertToDays(cur.unit, cur.value)
    const convertedAcc = convertToDays(acc.unit, acc.value)
    return convertedCur > convertedAcc ? cur : acc
  }, durations[0])
  return max
}

export const minDuration = (durations: CalendarDuration[]) => {
  if (!durations?.length) {
    return null
  }

  const min = durations?.reduce((acc, cur) => {
    if (cur.value == null || acc.value == null) return acc
    const convertedCur = convertToDays(cur.unit, cur.value)
    const convertedAcc = convertToDays(acc.unit, acc.value)
    return convertedCur < convertedAcc ? cur : acc
  }, durations[0])
  return min
}

/**
 * Sorts an array by a duration property
 */
export const sortByDuration = (a: CalendarDuration, b: CalendarDuration) => {
  return convertToDays(a.unit, a.value ?? 0) - convertToDays(b.unit, b.value ?? 0)
}
